export const HostedInstanceHostingTaskLimitValues = [
    5,
    10,
    20,
    40,
    80,
    160,
    320
] as const
